var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Notification } from '../../components/Notification';
export var HandleError = function (_a) {
    var error = _a.error, handleClose = _a.handleClose;
    var _b = useState({
        open: false,
        message: '',
        severity: 'error',
        duration: 6000,
        vertical: 'top'
    }), notification = _b[0], setNotification = _b[1];
    var handleError = function (err) {
        var _a, _b, _c, _d, _e, _f, _g;
        if (err !== undefined && Object.keys(err).length > 0) {
            if (((_b = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.details) && ((_e = (_d = (_c = err === null || err === void 0 ? void 0 : err.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.details) === null || _e === void 0 ? void 0 : _e.length) > 0) {
                var details = err.response.data.details;
                var message_1 = 'Erros Encontrados: ';
                details.forEach(function (it) {
                    message_1 += " - ".concat(it.split(':').join(' \n -'), ",");
                });
                setNotification(__assign(__assign({}, notification), { open: true, message: message_1 }));
            }
            else if ((_g = (_f = err === null || err === void 0 ? void 0 : err.response) === null || _f === void 0 ? void 0 : _f.data) === null || _g === void 0 ? void 0 : _g.message) {
                setNotification(__assign(__assign({}, notification), { open: true, message: err.response.data.message }));
            }
            else if (typeof err === 'string') {
                setNotification(__assign(__assign({}, notification), { open: true, message: err }));
            }
            else {
                setNotification(__assign(__assign({}, notification), { open: true, message: 'Falha na comunicação com o servidor.' }));
            }
        }
    };
    useEffect(function () {
        handleError(error);
    }, [error]);
    var handleFormChange = function (props) {
        if (!props.open) {
            handleClose();
        }
        setNotification(props);
    };
    return (_jsx(Notification, { props: notification, handleFormChange: handleFormChange }));
};
